var render = function render(){
  var _vm$detail$customer_c;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-modal', {
    attrs: {
      "title": "Modal Filter",
      "ok-title": "Apply Filter"
    },
    on: {
      "ok": function ok($event) {
        _vm.activeTab === 'active' ? _vm.fetchCustomers() : _vm.fetchCustomerProspects();
      }
    },
    model: {
      value: _vm.showModalFilter,
      callback: function callback($$v) {
        _vm.showModalFilter = $$v;
      },
      expression: "showModalFilter"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Used For",
      "label-for": "fleet",
      "label-cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "fleet",
      "multiple": "",
      "placeholder": "Select Vehicle Type",
      "label": "name",
      "options": _vm.typeFleet,
      "reduce": function reduce(opt) {
        return opt.code;
      }
    },
    model: {
      value: _vm.activeTab === 'active' ? _vm.equipment.params.vehicleTypeIds : _vm.equipment.prospectParams.vehicleTypeIds,
      callback: function callback($$v) {
        _vm.$set(_vm.activeTab === 'active' ? _vm.equipment.params.vehicleTypeIds : _vm.equipment.prospectParams, "vehicleTypeIds", $$v);
      },
      expression: "\n          activeTab === 'active'\n            ? equipment.params.vehicleTypeIds\n            : equipment.prospectParams.vehicleTypeIds\n        "
    }
  })], 1), _c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Status",
      "label-for": "active",
      "label-cols": "3"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.equipment.params.active,
      callback: function callback($$v) {
        _vm.$set(_vm.equipment.params, "active", $$v);
      },
      expression: "equipment.params.active"
    }
  }, [_vm.equipment.params.active === false ? [_vm._v("No")] : [_vm._v("Yes")]], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "title": "Import Data",
      "ok-title": "Submit"
    },
    on: {
      "ok": _vm.handleImport
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-primary"
        }, [_vm._v("Import Data")]), _c('i', {
          staticClass: "fa fa-times cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showModalImport = false;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showModalImport,
      callback: function callback($$v) {
        _vm.showModalImport = $$v;
      },
      expression: "showModalImport"
    }
  }, [[_c('div', {
    staticClass: "flex flex-column align-items-center"
  }, [_c('b-form-file', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    model: {
      value: _vm.importFile,
      callback: function callback($$v) {
        _vm.importFile = $$v;
      },
      expression: "importFile"
    }
  }), _c('small', {
    staticClass: "text-black"
  }, [_vm._v("accept: .xlsx, .xls, .csv")])], 1), _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Template ")])]], 2), _c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("Costumer")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mb-4"
        }, [_c('CustomNav', {
          attrs: {
            "items": _vm.tabs
          },
          on: {
            "item-click": function itemClick(tab) {
              return _vm.activeTab = tab;
            }
          }
        })], 1), _c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('b-form', {
          staticClass: "d-flex mb-3",
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              _vm.activeTab === 'active' ? _vm.fetchCustomers() : _vm.fetchCustomerProspects();
            }
          }
        }, [_vm.activeTab === 'prospect' ? _c('b-form-input', {
          staticClass: "mr-2",
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "type": "text",
            "placeholder": "Search..."
          },
          on: {
            "input": _vm.handleSearchInput
          },
          model: {
            value: _vm.equipment.prospectParams.search,
            callback: function callback($$v) {
              _vm.$set(_vm.equipment.prospectParams, "search", $$v);
            },
            expression: "equipment.prospectParams.search"
          }
        }) : _vm._e(), _vm.activeTab === 'active' ? _c('b-form-input', {
          staticClass: "mr-2",
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "type": "text",
            "placeholder": "Search..."
          },
          on: {
            "input": _vm.handleSearchInput
          },
          model: {
            value: _vm.equipment.params.search,
            callback: function callback($$v) {
              _vm.$set(_vm.equipment.params, "search", $$v);
            },
            expression: "equipment.params.search"
          }
        }) : _vm._e(), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "type": "submit",
            "variant": "primary",
            "disabled": _vm.isLoading
          }
        }, [_vm.isLoading ? _c('b-spinner', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }) : _c('i', {
          staticClass: "fa fa-search"
        }), _vm.isLoading ? _c('span', [_vm._v("Loading...")]) : _vm._e()], 1), _c('div', [_c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "type": "button",
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.showModalFilter = true;
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-sliders"
        }), _vm._v(" Filter Data ")])], 1)], 1), _c('div', {
          staticClass: "d-flex"
        }, [_c('b-button', {
          staticClass: "mr-2 d-flex align-items-center",
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.exportData
          }
        }, [_c('i', {
          staticClass: "ri-upload-2-line pl-1"
        }), _vm._v(" Export ")]), _vm.activeTab == 'prospect' ? [_c('b-button', {
          staticClass: "d-flex align-items-center mr-2",
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.showModalImport = true;
            }
          }
        }, [_c('i', {
          staticClass: "ri-download-2-line pl-1"
        }), _vm._v(" Import ")]), _c('b-button', {
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.openSidebar();
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus mr-1"
        }), _vm._v(" New Customer Prospect ")])] : _vm._e()], 2)], 1), _c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table table-bordered table-striped"
        }, [_c('thead', {
          staticClass: "thead-light"
        }, [_c('tr', [_vm.activeTab == 'active' ? _c('th', {
          staticClass: "text-nowrap column-1"
        }, [_vm._v(" Customer Id ")]) : _vm._e(), _c('th', {
          staticClass: "text-nowrap column-2",
          style: {
            left: _vm.activeTab == 'active' ? '160px' : '0px'
          }
        }, [_vm._v(" Customer Name ")]), _c('th', {
          staticClass: "text-nowrap"
        }, [_vm._v("Customer Class")]), _vm.activeTab == 'active' ? _c('th', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Currency ")]) : _vm._e(), _vm.activeTab == 'active' ? _c('th', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Terms ")]) : _vm._e(), _c('th', {
          staticClass: "text-nowrap"
        }, [_vm._v("Job Title")]), _c('th', {
          staticClass: "text-nowrap"
        }, [_vm._v("Pic No. Handphone")]), _c('th', {
          staticClass: "text-nowrap"
        }, [_vm._v("Pic Email")]), _c('th', {
          staticClass: "text-nowrap"
        }, [_vm._v("Country")]), _c('th', {
          staticClass: "text-nowrap"
        }, [_vm._v("City")]), _c('th', {
          staticClass: "text-nowrap",
          staticStyle: {
            "width": "240px",
            "max-width": "240px"
          }
        }, [_vm._v("Address")]), _c('th', {
          staticClass: "text-center text-nowrap",
          staticStyle: {
            "min-width": "100px"
          }
        }, [_vm._v(" Status ")]), _c('th', {
          staticClass: "text-center text-nowrap column-action"
        }, [_vm._v("Action")])])]), _vm.isLoading ? _c('tbody', [_c('tr', [_c('td', {
          staticClass: "text-center py-5",
          attrs: {
            "colspan": _vm.activeTab === 'active' ? 11 : 10
          }
        }, [_c('b-spinner', {
          staticStyle: {
            "width": "3rem",
            "height": "3rem"
          },
          attrs: {
            "variant": "primary"
          }
        }), _c('div', {
          staticClass: "mt-2 text-muted"
        }, [_vm._v("Loading data...")])], 1)])]) : _vm.activeTab === 'active' ? _c('tbody', _vm._l(_vm.listCustomerActive, function (item, index) {
          var _item$financial, _item$financial$curre, _item$financial2, _item$financial2$term;
          return _c('tr', {
            key: "a-".concat(index)
          }, [_vm.activeTab == 'active' ? _c('td', {
            staticClass: "text-nowrap column-1 bg-white"
          }, [_vm._v(" " + _vm._s(item.customer_code) + " ")]) : _vm._e(), _c('td', {
            staticClass: "text-nowrap column-2 bg-white",
            style: {
              left: _vm.activeTab == 'active' ? '160px' : '0px'
            }
          }, [_vm._v(" " + _vm._s(item.account_name) + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(item.customer_class.name || '-') + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(((_item$financial = item.financial) === null || _item$financial === void 0 ? void 0 : (_item$financial$curre = _item$financial.currency) === null || _item$financial$curre === void 0 ? void 0 : _item$financial$curre.currency) || '-') + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(((_item$financial2 = item.financial) === null || _item$financial2 === void 0 ? void 0 : (_item$financial2$term = _item$financial2.terms) === null || _item$financial2$term === void 0 ? void 0 : _item$financial2$term.description) || '-') + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(_vm.getContactValue(item.contact, 'job_title')) + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(_vm.getContactValue(item.contact, 'phone')) + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(_vm.getContactValue(item.contact, 'email')) + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(_vm._s(item.country_id || '-'))]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(_vm._s(item.city || '-'))]), _c('td', {
            directives: [{
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: {
                "hover": true
              }
            }],
            staticClass: "address-column",
            staticStyle: {
              "width": "240px",
              "max-width": "240px"
            },
            attrs: {
              "title": item.address || '-'
            }
          }, [_c('div', {
            staticClass: "address-text"
          }, [_vm._v(" " + _vm._s(item.address || '-') + " ")])]), _c('td', {
            staticClass: "text-center"
          }, [_c('span', {
            staticClass: "badge badge-pill",
            class: {
              'badge-success': item.customer_status === 'active',
              'badge-warning': item.customer_status === 'requested',
              'badge-danger': item.customer_status === 'blacklist'
            }
          }, [_vm._v(" " + _vm._s(item.customer_status) + " ")])]), _c('td', {
            staticClass: "text-center column-action bg-white"
          }, [_c('b-button', {
            attrs: {
              "id": "popover-action",
              "variant": "primary",
              "size": "sm"
            }
          }, [_vm._v(" Action ")]), _c('b-popover', {
            attrs: {
              "target": "popover-action",
              "triggers": "focus",
              "placement": "bottom"
            }
          }, [_c('div', {
            staticClass: "d-flex flex-column text-left"
          }, [_c('b-button', {
            staticClass: "p-0 text-dark text-left",
            attrs: {
              "variant": "link"
            },
            on: {
              "click": function click() {
                _vm.showDetailCustomer(item);
              }
            }
          }, [_vm._v(" Detail Customer ")])], 1)])], 1)]);
        }), 0) : !_vm.isLoading ? _c('tbody', _vm._l(_vm.listCustomerProspect, function (item, index) {
          var _item$customer_status, _item$customer_status2, _item$customer_status3;
          return _c('tr', {
            key: "p-".concat(index)
          }, [_vm.activeTab == 'active' ? _c('td', {
            staticClass: "text-nowrap column-1 bg-white"
          }) : _vm._e(), _c('td', {
            staticClass: "text-nowrap column-2 bg-white",
            style: {
              left: _vm.activeTab == 'active' ? '160px' : '0px'
            }
          }, [_vm._v(" " + _vm._s(item.account_name || item.name) + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(_vm._s(item.customer_class || '-'))]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(item.primary_job_title || '-') + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(item.primary_mobile_phone || '-') + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(_vm._s(item.primary_email || '-'))]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(item.country_id || item.country || '-') + " ")]), _c('td', {
            staticClass: "text-nowrap"
          }, [_vm._v(_vm._s(item.city || '-'))]), _c('td', {
            directives: [{
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: {
                "hover": true
              }
            }],
            staticClass: "address-column",
            staticStyle: {
              "width": "240px",
              "max-width": "240px"
            },
            attrs: {
              "title": item.address || '-'
            }
          }, [_c('div', {
            staticClass: "address-text"
          }, [_vm._v(" " + _vm._s(item.address || '-') + " ")])]), _c('td', {
            staticClass: "text-center"
          }, [_c('span', {
            staticClass: "badge badge-pill",
            class: {
              'badge-success': ((_item$customer_status = item.customer_status) === null || _item$customer_status === void 0 ? void 0 : _item$customer_status.toLowerCase()) === 'active',
              'badge-warning': ((_item$customer_status2 = item.customer_status) === null || _item$customer_status2 === void 0 ? void 0 : _item$customer_status2.toLowerCase()) === 'requested' || item.status === 'prospect',
              'badge-danger': ((_item$customer_status3 = item.customer_status) === null || _item$customer_status3 === void 0 ? void 0 : _item$customer_status3.toLowerCase()) === 'blacklist'
            }
          }, [_vm._v(" " + _vm._s(item.customer_status || item.status || 'prospect') + " ")])]), _c('td', {
            staticClass: "text-center column-action bg-white"
          }, [_c('b-button', {
            attrs: {
              "id": "popover-action-prospect-".concat(index),
              "variant": "primary",
              "size": "sm"
            }
          }, [_vm._v(" Action ")]), _c('b-popover', {
            ref: "popoverProspect-".concat(index),
            refInFor: true,
            attrs: {
              "target": "popover-action-prospect-".concat(index),
              "triggers": "focus",
              "placement": "bottom"
            }
          }, [_c('div', {
            staticClass: "d-flex flex-column text-left"
          }, [_c('b-button', {
            staticClass: "p-0 text-dark text-left",
            attrs: {
              "variant": "link"
            },
            on: {
              "click": function click() {
                _vm.closeProspectPopover(index);
                _vm.showDetailCustomer(item, true);
              }
            }
          }, [_vm._v(" Detail Customer ")]), _c('b-button', {
            staticClass: "p-0 text-dark text-left",
            attrs: {
              "variant": "link"
            },
            on: {
              "click": function click() {
                _vm.closeProspectPopover(index);
                _vm.openEditCustomer(item);
              }
            }
          }, [_vm._v(" Edit Customer ")])], 1)])], 1)]);
        }), 0) : _vm._e()])]), _c('div', {
          staticClass: "mt-4 d-flex align-items-center w-100 justify-content-end"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.activeTab === 'active' ? _vm.equipment.params.total : _vm.equipment.prospectParams.total,
            "per-page": _vm.currentLimit,
            "first-number": "",
            "align": "center",
            "disabled": _vm.isLoading
          },
          on: {
            "input": _vm.handlePageChange
          },
          model: {
            value: _vm.currentPage,
            callback: function callback($$v) {
              _vm.currentPage = $$v;
            },
            expression: "currentPage"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions,
            "disabled": _vm.isLoading
          },
          on: {
            "change": _vm.handleLimitChange,
            "input": function input() {
              return _vm.activeTab === 'active' ? _vm.fetchCustomers() : _vm.fetchCustomerProspects();
            }
          },
          model: {
            value: _vm.currentLimit,
            callback: function callback($$v) {
              _vm.currentLimit = $$v;
            },
            expression: "currentLimit"
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1), _c('custom-sidebar', {
    attrs: {
      "size": "80%",
      "title": "".concat(_vm.equipment.editMode ? 'Edit' : 'New', " Customer ").concat(_vm.activeTab === 'prospect' ? 'Prospect' : '')
    },
    model: {
      value: _vm.showSidebar,
      callback: function callback($$v) {
        _vm.showSidebar = $$v;
      },
      expression: "showSidebar"
    }
  }, [_vm.showSidebar ? _c('FormCustomerNew', {
    attrs: {
      "value": _vm.equipment.detailData
    },
    on: {
      "close": function close($event) {
        _vm.showSidebar = false;
      },
      "submitted": _vm.afterFormSubmit
    }
  }) : _vm._e()], 1), _c('custom-sidebar', {
    attrs: {
      "size": "90%",
      "title": "Customer Detail"
    },
    model: {
      value: _vm.showDetail,
      callback: function callback($$v) {
        _vm.showDetail = $$v;
      },
      expression: "showDetail"
    }
  }, [_c('div', {
    staticClass: "p-3 bg-white"
  }, [_c('CustomNav', {
    attrs: {
      "items": _vm.detailTabs
    },
    on: {
      "item-click": function itemClick(t) {
        return _vm.detailActiveTab = t;
      }
    }
  }), _vm.detailActiveTab === 'general' ? _c('div', {
    staticClass: "mt-4"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "section-title mb-3"
  }, [_c('h6', [_vm._v("ACCOUNT INFO")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Account Name")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.account_name || _vm.detail.name || '-') + " ")])]), _vm.activeTab == 'active' ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Customer ID")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.customer_code || '-') + " ")])]) : _vm._e(), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Customer Status")]), _c('div', {
    staticClass: "font-weight-bold text-capitalize"
  }, [_vm._v(" " + _vm._s(_vm.detail.customer_status || _vm.detail.status || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Customer Class")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(((_vm$detail$customer_c = _vm.detail.customer_class) === null || _vm$detail$customer_c === void 0 ? void 0 : _vm$detail$customer_c.name) || _vm.detail.customer_class || 'DEFAULT') + " ")])])], 1), _c('div', {
    staticClass: "section-title my-3"
  }, [_c('h6', [_vm._v("ACCOUNT ADDRESS")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Country")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.country || _vm.detail.country_id || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Provience")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.province || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("City")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.detail.city || '-'))])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("District")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.district || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Sub District")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.sub_district || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Postal Code")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.postal_code || '-') + " ")])]), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('small', [_vm._v("Address")]), _c('div', {
    staticClass: "font-weight-bold="
  }, [_vm._v(" " + _vm._s(_vm.detail.address || '-') + " ")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "section-title mb-3"
  }, [_c('h6', [_vm._v("ADDITIONAL ACCOUNT INFO")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Website")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.detail.web || '-'))])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Fax")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.detail.fax || '-'))])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Assistant")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.assistance || '-') + " ")])])], 1), _c('div', {
    staticClass: "section-title my-3"
  }, [_c('h6', [_vm._v("PRIMARY CONTACT")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Name")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.primary_name || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Job Title")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.primary_job_title || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Email")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.primary_email || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Phone 1")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.primary_phone || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Mobile Phone 1")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.primary_mobile_phone || '-') + " ")])])], 1)], 1)], 1)], 1) : _vm.detailActiveTab === 'billing' ? _c('div', {
    staticClass: "mt-4"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "section-title mb-3"
  }, [_c('h6', [_vm._v("BILL TO ADDRESS")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Country")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.bill_country || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Provience")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.bill_province || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("City")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.bill_city || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("District")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.bill_district || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Sub District")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.bill_sub_district || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Postal Code")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.bill_postal_code || '-') + " ")])]), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('small', [_vm._v("Address")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.bill_address || '-') + " ")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "section-title mb-3"
  }, [_c('h6', [_vm._v("BILL TO INFO")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Account Name")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.detail.primary_name || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Attention")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.attention || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Business 1")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.business_1 || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Business 2")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.business_2 || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Business 3")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.business_3 || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Fax")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.fax || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Home")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.home || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Home Fax")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.home_fax || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Email")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.email || '-') + " ")])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('small', [_vm._v("Web")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.firstBilling.web || '-') + " ")])])], 1)], 1)], 1)], 1) : _vm.detailActiveTab === 'contact' ? _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("Name")]), _c('th', [_vm._v("Department")]), _c('th', [_vm._v("Job Title")]), _c('th', [_vm._v("Email")]), _c('th', [_vm._v("Mobile Phone")])])]), _c('tbody', _vm._l(_vm.detail.contacts || _vm.detail.contact || [], function (c, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(_vm._s(c.name || '-'))]), _c('td', [_vm._v(_vm._s(c.department || '-'))]), _c('td', [_vm._v(_vm._s(c.job_title || c.jobTitle || '-'))]), _c('td', [_vm._v(_vm._s(c.email || '-'))]), _c('td', [_vm._v(_vm._s(c.mobile_phone || c.mobile || '-'))])]);
  }), 0)])])]) : _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("Document Name")]), _c('th', [_vm._v("Document Upload")])])]), _c('tbody', _vm._l(_vm.detail.documents || [], function (d, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', [_vm._v(_vm._s(d.document_name || d.name))]), _c('td', [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-primary",
        "disabled": !d.file_path
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Download ")])], 1)]);
  }), 0)])])])], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }